"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpUnattemptedStudentModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DpModal_1 = require("../Modal/DpModal");
var react_i18next_1 = require("react-i18next");
var DpUnattemptedStudentModal_styled_1 = require("./DpUnattemptedStudentModal.styled");
var api_1 = require("../../../api");
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var DpUnattemptedStudentModal = function (_a) {
    var show = _a.show, assessment = _a.assessment, closeHandler = _a.closeHandler;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- State
    var _b = (0, react_1.useState)(null), unattemptedStudents = _b[0], setUnattemptedStudents = _b[1];
    var _c = (0, react_1.useState)(false), initialized = _c[0], setInitialized = _c[1];
    // --------------------------- Context
    var _d = (0, react_1.useContext)(api_1.ServiceContext), assigneeUsageService = _d.assigneeUsageService, userService = _d.userService;
    // ------------------------------- Methods
    var fetchUnattemptedStudentData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, assessmentClass, assessmentTemplate, unattemptedStudentIds, unattemptedStudentsName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = assessment.id, assessmentClass = assessment.assessmentClass, assessmentTemplate = assessment.assessmentTemplate;
                    unattemptedStudentIds = [];
                    if (!assessmentTemplate.curriculum.startsWith(api_1.CurriculumId.EurekaMath)) return [3 /*break*/, 2];
                    return [4 /*yield*/, assigneeUsageService.findUnattemptedAssigneesByContextAndTemplate(assessmentClass.id, assessmentTemplate.id)];
                case 1:
                    unattemptedStudentIds =
                        _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(assessmentTemplate.curriculum === api_1.CurriculumId.WitAndWisdom)) return [3 /*break*/, 4];
                    return [4 /*yield*/, assigneeUsageService.findUnattemptedAssigneesByAssessment(id)];
                case 3:
                    unattemptedStudentIds = _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, userService.findByIds(unattemptedStudentIds, true, true)];
                case 5:
                    unattemptedStudentsName = _a.sent();
                    setUnattemptedStudents((0, sortBy_1.default)(unattemptedStudentsName, 'lastName'));
                    setInitialized(true);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, api_1.useMount)(function () {
        fetchUnattemptedStudentData();
    });
    return ((0, jsx_runtime_1.jsxs)(DpUnattemptedStudentModal_styled_1.StyledModal, { show: true, onHide: closeHandler, size: "lg", scrollable: true, "aria-labelledby": "unattempted-modal-title", dialogClassName: "unattempted-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h1", { className: "h4", id: "unattempted-modal-title", children: t('DpUnattemptedStudentModal.title') }) }) }), initialized && ((0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Body, { children: (0, jsx_runtime_1.jsx)("div", { className: "lti-unattempted-table", children: (0, jsx_runtime_1.jsxs)("table", { className: "table", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)("span", { children: t("DpUnattemptedStudentModal.columnName") }) }) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: unattemptedStudents.map(function (unattemptedStudent) { return ((0, jsx_runtime_1.jsx)("tr", { className: "shadow-hover-md", children: (0, jsx_runtime_1.jsxs)("td", { className: "name", children: [unattemptedStudent.lastName, " ", unattemptedStudent.firstName] }) }, unattemptedStudent.id)); }) })] }) }) }))] }));
};
exports.DpUnattemptedStudentModal = DpUnattemptedStudentModal;
exports.default = exports.DpUnattemptedStudentModal;
